import React from "react";

import RangeInput from "../../Layout/Inputs/RangeInput/";

const LetterSpacing = ({ letterSpacingAmt, onUpdateLetterSpacing }) => {
  const handleUpdateLetterSpacing = (event) => {
    onUpdateLetterSpacing(event.target.value);
  };

  const amount = letterSpacingAmt || 0;

  return (
    <div className="tool__letterspacing">
      <h4>Letter Spacing</h4>

      <RangeInput
        min="-3"
        max="3"
        step=".5"
        value={amount}
        handleOnChange={handleUpdateLetterSpacing}
      />
    </div>
  );
};

export default LetterSpacing;
